// src/app/shared/services/date-range-factory.service.ts
import { Injectable } from '@angular/core';
import { DateRangeOption } from '../interfaces/date-range';
import { DateUtils } from '../utils/date-utils';

@Injectable({ providedIn: 'root' })
export class DateRangeFactoryService {
  getDefaultRanges(): DateRangeOption[] {
    return [
      {
        value: [DateUtils.daysAgo(7), DateUtils.today()],
        label: $localize`Últimos 7 Dias`,
      },
      {
        value: [DateUtils.today(), DateUtils.daysAhead(7)],
        label: $localize`Próximos 7 Dias`,
      },
      {
        value: [DateUtils.monthsAgo(1), DateUtils.today()],
        label: $localize`Último mês`,
      },
      {
        value: [DateUtils.today(), DateUtils.monthsAhead(1)],
        label: $localize`Próximo mês`,
      },
      {
        value: [DateUtils.monthsAgo(6), DateUtils.today()],
        label: $localize`Últimos 6 meses`,
      },
      {
        value: [DateUtils.today(), DateUtils.monthsAhead(6)],
        label: $localize`Próximos 6 meses`,
      },
    ];
  }
  
  getVendasRanges(): DateRangeOption[] {
    return [
      {
        value: [DateUtils.daysAgo(7), DateUtils.today()],
        label: $localize`Últimos 7 Dias`,
      },
      {
        value: [DateUtils.monthsAgo(1), DateUtils.today()],
        label: $localize`Último mês`,
      },
      {
        value: [DateUtils.monthsAgo(6), DateUtils.today()],
        label: $localize`Últimos 6 meses`,
      },
    ];
  }
}


